import { NgZone } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * The sync engine works inside navigator.locks.request, which zone.js does not patch: its emissions arrive outside
 * the Angular zone and no change detection follows (Schritt 2: badges stayed 30–45 s). Subscribers run in the zone.
 */
export function inAngularZone<T>(zone: NgZone, source: Observable<T>): Observable<T> {
  return new Observable<T>((subscriber) =>
    source.subscribe({
      next: (value) => zone.run(() => subscriber.next(value)),
      error: (error: unknown) => zone.run(() => subscriber.error(error)),
      complete: () => zone.run(() => subscriber.complete()),
    }),
  );
}
